export const UPDATE_PROFIT_BY_STORE_WIDGET = "UPDATE_PROFIT_BY_STORE_WIDGET";